import { supabase } from '../supabase'

// Tarif de la journee d'accueil pour une date donnee.
// - majore : jours_planning.accueil_majore (ferie, ou samedi sans Anne-Julie)
// - montant : tarifs_journee (versionne par date_effet), a defaut l'ancienne table tarif_accueil
//   pour les dates anterieures a la premiere ligne de tarifs_journee.
// montant vaut null si aucun tarif n'est trouve : l'appelant doit alors le signaler.
export async function tarifAccueilPour(date) {
  const { data: jour } = await supabase.from('jours_planning')
    .select('accueil_majore').eq('date', date).maybeSingle()
  const majore = !!(jour && jour.accueil_majore)
  const code = majore ? 'ACCUEIL_MAJORE' : 'ACCUEIL'

  const { data: t } = await supabase.from('tarifs_journee')
    .select('montant').eq('code', code).lte('date_effet', date)
    .order('date_effet', { ascending: false }).limit(1)
  if (t && t.length > 0) return { montant: Number(t[0].montant), majore }

  if (!majore) {
    const { data: ancien } = await supabase.from('tarif_accueil')
      .select('montant').eq('actif', true)
      .lte('date_debut', date).or(`date_fin.is.null,date_fin.gte.${date}`)
      .order('date_debut', { ascending: false }).limit(1)
    if (ancien && ancien.length > 0) return { montant: Number(ancien[0].montant), majore }
  }
  return { montant: null, majore }
}
